import pushDataLayer, { type GAEvent } from "@ocm/services/dataLayer";
import { store } from "@/state/store";

export function pushEvent(action: string, label = "") {
	const prefix = "S_";
	const category = getEventCategory();

	const eventObj: GAEvent = {
		event: "GAevent",
		event_category: `${prefix}${category}`,
		event_action: `${prefix}${action}`,
		event_label: label ? `${prefix}${label}` : "",
	};

	pushDataLayer(eventObj);
}

function getEventCategory() {
	const type = (store.isLogin && "Login") || "Registration";
	const form = (!store.isLandingPage && "Layer") || "Form";

	return (store.isLastStepPage && "RegisterConfirmation") || `${type}${form}`;
}
